<template>
  <div class="emh-router-view">
    <template v-for="route in routes" :key="route.path">
      <component :is="route.component" v-if="route.isMatch"></component>
    </template>
  </div>
</template>

<script lang="ts">
import { match } from '@seamless/router';
import { defineComponent, shallowRef, watch } from 'vue';
import { useRoute, useRouter } from '../../../composables/router.composable';
import SeamlessRouterImpl from '../../../router/seamless-router-impl';
import { SeamlessRouteConfig } from '../../../router/types';

type MatchedRoute = SeamlessRouteConfig & { isMatch: boolean };

export default defineComponent({
  name: 'EmhRouterView',

  setup() {
    const router = useRouter() as SeamlessRouterImpl;
    const currentRoute = useRoute();
    const routes = shallowRef<MatchedRoute[]>([]);

    watch(
      currentRoute,
      () => {
        routes.value = (router.routes as SeamlessRouteConfig[])
          // Filter out pathless and componentless routes (e.g. redirect routes)
          .filter((route) => !!route.path && !!route.component)
          .map((route): MatchedRoute => {
            return {
              component: route.component,
              path: route.path,
              isMatch: match(router.namespace, route.path!, route.options).isMatch,
            };
          });
      },
      { immediate: true },
    );

    return { routes };
  },
});
</script>
